import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { uniqueId } from 'utils/strings'
import { copyTable } from 'utils/contents'
import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

const StyledWrapper = styled.span`
`

const CopyIcon = ({ copyText, copyHtml, tooltipPlace = 'left', icon, tooltipText, color, className, tableId }) => {
  const { t } = useTranslation()
  const id = useMemo(() => uniqueId(), [])
  const tooltipCopyId = `tooltip-copy-${id}`
  const tooltipCopyDoneId = `tooltip-copy-done-${id}`
  const showCopyIcon = !!copyText || copyText === 0 || !!tableId
  const TooltipText = tooltipText || t('common.tooltipCopy')
  const IconName = icon || 'icon-copy-14'

  if (!showCopyIcon) {
    return null
  }

  const onClick = async () => {
    if (tableId) {
      copyTable(tableId)
    } else {
      const clipboardContent = {
        'text/plain': new Blob([copyText], { type: 'text/plain' }),
      }
      if (copyHtml) {
        clipboardContent['text/html'] = new Blob([copyHtml], { type: 'text/html' })
      }

      const data = [new ClipboardItem(clipboardContent)]
      await navigator.clipboard.write(data)
    }
  }

  return (
    <>
      <Tooltip
        id={tooltipCopyId}
        place={tooltipPlace}
        delayHide={500}
        closeEvents={{ mouseleave: true, click: true }}
      />
      <Tooltip
        id={tooltipCopyDoneId}
        place={tooltipPlace}
        openEvents={{ click: true }}
      />
      <StyledWrapper
        className={className}
        data-tooltip-id={tooltipCopyId}
        data-tooltip-content={TooltipText}
      >
        <IconLink
          onClick={onClick}
          iconName={IconName}
          data-tooltip-content={t('common.tooltipCopied')}
          data-tooltip-id={tooltipCopyDoneId}
          color={color}
        />
      </StyledWrapper>
    </>
  )
}

CopyIcon.propTypes = {
  copyText: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  copyHtml: PropTypes.string,
  tooltipPlace: PropTypes.string,
  icon: PropTypes.string,
  tooltipText: PropTypes.string,
  color: PropTypes.string,
  tableId: PropTypes.string,
}

export default CopyIcon
